var _g, _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCultivable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9497 53H3.94971C6.55484 60.8671 11.5275 67.7052 18.1661 72.5496C24.8046 77.394 32.774 80 40.9497 80C49.1254 80 57.0948 77.394 63.7333 72.5496C70.3719 67.7052 75.3446 60.8671 77.9497 53Z",
    fill: "#EDFAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0347 66.6143L41.8647 67.9133",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.758 60.7969L47.519 60.9299",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4058 65.0755L29.1338 63.2275",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6636 62.5428L14.7286 60.2998",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7578 70.041L58.9728 70.398",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3169 76.0191L35.2839 73.9941",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2407 71.9819L50.2967 71.0859",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0527 70.1676L23.0187 68.1426",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2499 53.7178H3.6499",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1066 29.9609C50.1066 29.9609 48.5706 36.8329 51.9496 40.4959C53.8066 42.5089 57.1036 42.5869 58.4126 38.9629C62.1296 37.9489 62.3766 33.8119 60.0066 32.4399C57.3576 30.9059 54.4606 33.7059 50.1066 29.9609Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8944 34.251C71.8944 34.251 73.6674 39.627 71.2534 42.826C69.9264 44.583 67.2964 44.907 65.9614 42.111C62.9064 41.594 62.3814 38.304 64.1694 37.019C66.1674 35.581 68.7074 37.592 71.8944 34.251Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1207 42.6822C38.0005 42.0647 38.1012 41.4246 38.4052 40.8738C38.7092 40.323 39.1971 39.8966 39.7837 39.6692C41.7177 38.8422 44.8157 39.8182 46.1047 39.2692C47.3937 38.7202 43.0087 45.4822 38.1207 42.6822Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5085 48.3773C36.3761 47.7623 36.0318 47.2135 35.5357 46.8267C35.0396 46.4399 34.4233 46.2398 33.7945 46.2613C31.6945 46.2613 29.2265 48.3773 27.8245 48.3773C26.4225 48.3773 33.1165 52.8743 36.5085 48.3773Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0828 53.409C33.8828 46.461 39.6068 45.843 38.1618 42.709",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1114 49.2056C16.5398 48.8721 17.5118 47.8048 17.2823 46.8217C17.0528 45.8385 15.7088 45.3118 14.2803 45.6453C12.8518 45.9787 11.8799 47.046 12.1094 48.0292C12.3389 49.0123 13.6829 49.539 15.1114 49.2056Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2827 46.8232C18.0873 48.3901 18.4161 50.1579 18.2287 51.9092C18.2287 51.9092 17.3207 54.8592 18.1127 56.7552",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7998 60.0882C38.0428 56.7492 35.3688 55.1832 38.0828 53.4092C41.4668 54.6302 38.2588 58.2552 42.1828 58.9212",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8687 46.7705V55.5045",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8688 55.5049C57.9938 56.7489 60.4418 61.7049 57.7998 62.9209",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8058 58.1152C59.3275 58.6911 58.7365 59.1631 58.0691 59.5023C57.4017 59.8414 56.672 60.0405 55.9248 60.0872",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8687 55.5049C67.7437 56.7489 65.8977 60.6289 68.5396 61.8479",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5374 58.6758C65.9736 59.3721 65.666 60.2409 65.666 61.1368C65.666 62.0327 65.9736 62.9015 66.5374 63.5978",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8688 55.5049C62.8688 55.5049 61.7898 58.0049 62.7268 59.9419C63.6638 61.8789 62.8688 65.0979 62.8688 65.0979",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1096 61.2852C62.5048 62.2359 61.6321 62.9865 60.6016 63.4422",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3835 38.7531C65.4585 41.4811 62.8685 46.7711 62.8685 46.7711C62.8685 46.7711 61.2175 38.2391 53.8105 35.5381",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3032 8.79V7",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7069 11.9359L17.4419 10.6709",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.561 19.5322H13.771",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7069 27.1279L17.4419 28.3939",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4961 11.9359L35.7611 10.6709",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6421 19.5322H39.4321",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4961 27.1279L35.7611 28.3939",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3032 30.2744V32.0644",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3028 27.8868C30.9171 27.8868 34.6578 24.1461 34.6578 19.5318C34.6578 14.9174 30.9171 11.1768 26.3028 11.1768C21.6884 11.1768 17.9478 14.9174 17.9478 19.5318C17.9478 24.1461 21.6884 27.8868 26.3028 27.8868Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-crop-rotation",
    viewBox: "0 0 82 82",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1271 3C16.1271 3 13.3401 16.1996 20.2641 23.0696C24.0641 26.8421 30.6701 26.8593 33.1401 19.8776C40.5401 17.7894 40.8601 9.86905 36.0571 7.34162C30.6871 4.51532 25.0021 9.98172 16.1271 3Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3601 12.0879C57.3601 12.0879 59.8231 21.4385 55.1151 26.5755C52.5301 29.3971 47.8081 29.6243 45.7931 24.7108C40.4261 23.4571 39.9161 17.8035 43.2601 15.8404C47.0001 13.6443 51.2611 17.3719 57.3601 12.0879Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0078 56.8939C44.6288 54.3521 45.9508 51.1582 48.6718 51.1582",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1444 51.3154C48.9444 51.0624 50.2724 47.5811 54.1604 47.5811C58.0484 47.5811 62.6024 51.3154 65.1944 51.3154C67.7864 51.3154 55.4144 59.251 49.1444 51.3154Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7631 47.2106C37.3299 45.996 36.4986 44.9469 35.3921 44.2188C34.2857 43.4906 32.963 43.1221 31.6201 43.1679",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6201 43.1679C31.8201 42.9159 30.4921 39.4336 26.6051 39.4336C22.7181 39.4336 18.1621 43.1679 15.5701 43.1679C12.9781 43.1679 25.3511 51.1035 31.6201 43.1679Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2764 65.5747L33.4424 65.6148C37.944 66.6852 42.6518 66.6852 47.1534 65.6148L47.3194 65.5747C47.3194 65.5747 44.8194 61.2636 40.2974 32.8994C35.6104 61.2636 33.2764 65.5747 33.2764 65.5747Z",
    fill: "white",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56 19.6555C44.776 24.1614 40.291 32.8971 40.291 32.8971C40.291 32.8971 37.436 18.8067 24.623 14.3467",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 57C9.20959 63.8864 14.2453 69.699 20.5264 73.7675C26.8075 77.836 34.0782 79.9947 41.5 79.9947C48.9218 79.9947 56.1925 77.836 62.4736 73.7675C68.7547 69.699 73.7904 63.8864 77 57H6Z",
    fill: "#EDFAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7899 65.6119C35.1146 65.624 34.4485 65.454 33.8616 65.1197C33.2747 64.7853 32.7888 64.299 32.4549 63.7119C32.113 64.2928 31.6254 64.7743 31.0403 65.1088C30.4552 65.4433 29.7929 65.6193 29.1189 65.6193C28.4449 65.6193 27.7826 65.4433 27.1975 65.1088C26.6124 64.7743 26.1248 64.2928 25.7829 63.7119C25.4409 64.2925 24.9533 64.7738 24.3683 65.1082C23.7833 65.4426 23.1212 65.6185 22.4474 65.6185C21.7736 65.6185 21.1114 65.4426 20.5264 65.1082C19.9414 64.7738 19.4538 64.2925 19.1119 63.7119C18.778 64.2993 18.292 64.7858 17.7049 65.1202C17.1178 65.4546 16.4514 65.6244 15.7759 65.6119",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4758 68.4734C61.7998 68.4847 61.1333 68.3136 60.5462 67.9782C59.9592 67.6428 59.4734 67.1555 59.1398 66.5674C58.7977 67.1477 58.31 67.6288 57.725 67.963C57.1401 68.2972 56.478 68.473 55.8043 68.473C55.1306 68.473 54.4686 68.2972 53.8836 67.963C53.2986 67.6288 52.811 67.1477 52.4688 66.5674C52.1356 67.1558 51.6498 67.6433 51.0627 67.9788C50.4756 68.3142 49.8089 68.4851 49.1328 68.4734",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8191 74.6119C42.1436 74.624 41.4774 74.454 40.8904 74.1196C40.3034 73.7853 39.8172 73.299 39.4831 72.7119C39.1411 73.2925 38.6535 73.7738 38.0685 74.1082C37.4835 74.4426 36.8214 74.6185 36.1476 74.6185C35.4738 74.6185 34.8116 74.4426 34.2266 74.1082C33.6416 73.7738 33.154 73.2925 32.8121 72.7119C32.4781 73.2992 31.992 73.7856 31.4049 74.1199C30.8179 74.4543 30.1516 74.6242 29.4761 74.6119",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 58.2285H5",
    stroke: "#1EA77C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCultivable);
export default __webpack_public_path__ + "static/media/icon_cultivable.0bead34851328f813fd473fec9cc9681.svg";
export { ForwardRef as ReactComponent };